import type { IOffersDataLayer } from '@/types/DataLayer'

export function pushToDataLayer(data: object) {
  if (!window) {
    return
  }

  // @ts-expect-error dataLayer doesn't exist until it is included as script in nuxt.config
  window.dataLayer = window?.dataLayer || []
  // @ts-expect-error dataLayer doesn't exist until it is included as script in nuxt.config
  window.dataLayer.push(data)
}

export function pushOffersDataLayer(data: IOffersDataLayer) {
  pushToDataLayer({
    event: 'ga4_generic_event',
    generic_event_name: 'notification_icon',
    ...data
  })
}
